import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import './UnsavedTimesheetWarningModal.scss';

interface UnsavedTimesheetWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isSaving?: boolean;
}

const UnsavedTimesheetWarningModal: React.FC<UnsavedTimesheetWarningModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isSaving = false,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleConfirm = async () => {
    await onConfirm();
  };

  /* Portal to <body> so the modal always centers on the viewport,
     never trapped by an ancestor's transform/stacking context. */
  return createPortal(
    <div className="unsaved-timesheet-modal-overlay">
      <div className="unsaved-timesheet-modal-content">
        <div className="modal-header">
          <h2 className="modal-title">{t('UNSAVED_TIMESHEET_WARNING_TITLE')}</h2>
        </div>
        <div className="modal-body">
          <p className="modal-message">{t('UNSAVED_TIMESHEET_CONFIRMATION_MESSAGE')}</p>
        </div>
        <div className="modal-footer">
          <button 
            className="modal-btn modal-btn-secondary" 
            onClick={onClose}
            disabled={isSaving}
            style={{color: 'black'}}
          >
            {t('UNSAVED_TIMESHEET_CANCEL_BUTTON')}
          </button>
          <button 
            className="modal-btn modal-btn-primary" 
            onClick={handleConfirm}
            disabled={isSaving}
          >
            {isSaving ? t('SAVING') : t('UNSAVED_TIMESHEET_SAVE_CONTINUE_BUTTON')}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default UnsavedTimesheetWarningModal;
